import get from 'lodash.get';
import { captureMessage } from '@sentry/browser';

import appEvents from 'events/app';
import appSelectors from 'selectors/app';
import configSelectors from 'selectors/configuration';
import evaluateStage from 'actions/configuration/evaluateStage';

export default async function handleEstimatedWaitTime(dispatch, getState, { appGateway }) {
  const state = getState();
  const appId = appSelectors.getAppId(state.app);
  const orgId = appSelectors.getOrgId(state);
  const orgDomain = appSelectors.getOrgDomain(state);
  const autoThrottlingEnabled = configSelectors.getIsAutoThrottlingEnabled(state.configuration);

  if (!autoThrottlingEnabled) {
    return;
  }

  try {
    const response = await appGateway.getEstimatedWaitTime(orgDomain, orgId, appId);
    const estimatedWaitInMs = get(response, 'data', 0); // estimated wait comes back in milliseconds
    const estimatedWaitInSeconds = estimatedWaitInMs / 1000;

    dispatch(appEvents.fetchEstimatedWaitTimeSuccess(estimatedWaitInSeconds));
    dispatch(evaluateStage);
  } catch (error) {
    captureMessage(`fetch estimated wait time error: ${error}`);
  }
}
